import React from 'react';
import { useContent } from '../context/ContentContext';
import './PortfolioGrid.css';

const PortfolioGrid = ({ limit = null }) => {
  const { content } = useContent();
  const displayItems = limit ? content.portfolio.slice(0, limit) : content.portfolio;

  const handleItemClick = (item) => {
    // Add lightbox or detail view functionality here
    console.log('Portfolio item clicked:', item);
  };

  return (
    <section className="portfolio-section" id="portfolio">
      <div className="section-header fade-in-up">
        <h2 className="section-title">Portfolio</h2>
        <p className="section-subtitle">A curated selection of my finest work</p>
      </div>
      <div className="portfolio-grid stagger-container">
        {displayItems.map((item) => (
          <div
            key={item.id}
            className={`portfolio-item stagger-item smooth-hover ${item.large ? 'portfolio-item-large' : ''}`}
            data-category={item.category}
            onClick={() => handleItemClick(item)}
          >
            <div className="image-reveal">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="portfolio-overlay">
              <span className="portfolio-title">{item.title}</span>
              <span className="portfolio-category">{item.category}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioGrid;

